//#region Operations
export var IOperationType;
(function (IOperationType) {
    IOperationType[IOperationType["INSERT"] = 0] = "INSERT";
    IOperationType[IOperationType["DELETE"] = 1] = "DELETE";
    IOperationType[IOperationType["REPLACE"] = 2] = "REPLACE";
    IOperationType[IOperationType["FORMAT"] = 3] = "FORMAT";
    IOperationType[IOperationType["WRAP"] = 4] = "WRAP";
    IOperationType[IOperationType["UNWRAP"] = 5] = "UNWRAP";
})(IOperationType || (IOperationType = {}));
//#endregion
